export default {
  appKey: import.meta.env.VITE_APP_KEY || '',
  googleClientKey: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
  upbitWebsocketUrl: import.meta.env.VITE_WS_UPBIT_URL || '',
};
